import React from 'react';
import ContactForm from './ContactForm';
import { Col, Row } from 'react-bootstrap';
import { motion } from 'framer-motion';

const GetInTouch = ({ heading, message, email }) => {
  return (
    <>
      <Row id="getintouch">
        <Col>
          <motion.h2
            className="display-4 pb-3 text-center"
            initial={{ opacity: 0, y: -20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4 }}
            style={{ fontWeight: 700, color: 'var(--text-primary)' }}
          >
            {heading}
          </motion.h2>

          <motion.p
            className="lead text-center"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1, duration: 0.4 }}
            style={{ color: 'var(--text-secondary)', fontSize: '1.1rem' }}
          >
            {message},{' '}
            <a
              href={`mailto:${email}`}
              style={{
                color: 'var(--text-primary)',
                textDecoration: 'none',
                fontWeight: 600,
                borderBottom: '2px solid var(--text-primary)',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.opacity = '0.7';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.opacity = '1';
              }}
            >
              {email}
            </a>
            .
          </motion.p>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col lg="6">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2, duration: 0.4 }}
          >
            <ContactForm />
          </motion.div>
        </Col>
      </Row>
    </>
  );
};

export default GetInTouch;
